// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import './_product-highlights.scss';


const CALLOUT           = '.callout-item';
const CALLOUT_BUTTON    = '.callout__toggle-number';

$(CALLOUT_BUTTON).on('click', function(){
    var calloutData = $(this).data('callout-target');
    var calloutContent = $('#'+ calloutData);

    $(CALLOUT).removeClass('is--active');
    $(CALLOUT_BUTTON).removeClass('is--active');

    $(this).addClass('is--active');
    calloutContent.addClass('is--active');
});

